export enum GaFormType {
  Kontaktformular = 'Kontaktformular',
  GutscheinAnfordern = 'Gutschein anfordern',
}
